import { IReleaseNote } from "../types"

export const RELEASE_1_5_1: IReleaseNote = {
    status: "PAST",
    title: "v1.5.1",
    date: "3rd April 2025",
    releaseType: "Patch",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "This patch includes an update to Private API endpoint for submit assessment.",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "This release contains no changes to your functionality",
        },
        {
            heading: "For installers using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            content: "This release contains no changes to your functionality",
        },
        {
            heading: "For DNOs using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "The following changes have been been added:",
            bullets: [
                "We have included a fix for the Private API endpoint for submit assessment to ensure that the Heat Pump Assessment can be successfully processed.",
                "Due to an upgrade of dependency of a package, this caused a knock-on impact on Heat Pump assessment Application.",
                "The code has now been updated to handle these changes appropriately.",
            ],
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
}
